import React from 'react';
import Input, { InputSize, InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import TimeInput from '@zvuk-b2b/react-uikit/ui/TimeInput';
import EmenuPosterBadge from '../../EmenuPosterBadge';
import EmenuTitleWithTooltip from '../../EmenuTitleWithTooltip';
import { formatMillisecondsToTime, getRepeatsCount } from '../../utils';
import { DATA_TEST_IDS, DEFAULT_IMAGE_DURATION, TIME_PATTERN } from '../../consts';
import { TEXTS } from '../../texts';
import styles from './index.module.scss';

interface EmenuItemContentProps {
  title?: string | null;
  playDuration?: number | null;
  generationDuration?: number | null;
}

const EmenuItemContent: React.FC<EmenuItemContentProps> = ({ title, playDuration, generationDuration }) => {
  const repeatCount = getRepeatsCount(generationDuration, playDuration);

  return (
    <div className={styles.container}>
      <EmenuPosterBadge
        containerClassName={styles.posterContainer}
        posterClassName={styles.poster}
        badgeClassName={styles.badge}
        durationClassName={styles.duration}
        playDuration={playDuration}
      />
      <EmenuTitleWithTooltip
        title={title}
        testId={DATA_TEST_IDS.EMENU_ITEM_TITLE}
        containerClassName={styles.textContainer}
        popperClassName={styles.popper}
        titleClassName={styles.title}>
        {!generationDuration && (
          <TimeInput
            elementId={DATA_TEST_IDS.EMENU_DURATION_INPUT}
            value={formatMillisecondsToTime(playDuration || DEFAULT_IMAGE_DURATION)}
            containerClassName={styles.input}
            type={InputType.TEXT}
            isDisabled
            pattern={TIME_PATTERN}
            mask={TEXTS.TIME_MASK}
            placeholder={TEXTS.TIME_PLACEHOLDER}
            maxLength={8}
          />
        )}
        {!!generationDuration && (
          <Input
            value={String(repeatCount)}
            size={InputSize.MEDIUM}
            type={InputType.NUMBER}
            containerClassName={styles.input}
            maxLength={3}
            min={1}
            isDisabled
            autoComplete="off"
            elementId={DATA_TEST_IDS.EMENU_REPEATS_COUNT}
            placeholder="1"
          />
        )}
        {!!generationDuration && <div className={styles.description}>{TEXTS.VIDEO_HELP_TEXT}</div>}
      </EmenuTitleWithTooltip>
    </div>
  );
};

export default EmenuItemContent;
